var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 28V5.6C4 5.17565 4.18154 4.76869 4.50468 4.46863C4.82782 4.16857 5.26609 4 5.72308 4H17.9328C18.3895 4.00009 18.8274 4.16851 19.1504 4.46827L25.8957 10.7317C26.2185 11.0317 26.3999 11.4384 26.4 11.8624V16.8",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4001 12.25H19.3601C18.8933 12.25 18.4457 12.0762 18.1156 11.7667C17.7855 11.4573 17.6001 11.0376 17.6001 10.6V4",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8002 28V19.75L10.0002 23.875L7.2002 19.75V28",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28V19.75",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.75H16.8C17.4365 19.75 18.047 20.0266 18.4971 20.5188C18.9471 21.0111 19.2 21.6788 19.2 22.375C19.2 23.0712 18.9471 23.7389 18.4971 24.2312C18.047 24.7234 17.4365 25 16.8 25H16",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2002 21.4011C23.2002 20.9632 23.3702 20.5432 23.6729 20.2336C23.9756 19.924 24.3862 19.75 24.8142 19.75L26.0355 19.7555C26.5618 19.769 27.062 19.9927 27.4292 20.3787C27.7964 20.7647 28.0013 21.2824 28.0002 21.8209C27.9991 22.3595 27.792 22.8762 27.4232 23.2606C27.0544 23.645 26.5533 23.8665 26.0269 23.8778C26.5533 23.889 27.0544 24.1105 27.4232 24.4949C27.792 24.8793 27.9991 25.396 28.0002 25.9346C28.0013 26.4731 27.7964 26.9908 27.4292 27.3768C27.062 27.7628 26.5618 27.9865 26.0355 28H24.8142C24.3862 28 23.9756 27.826 23.6729 27.5164C23.3702 27.2068 23.2002 26.7868 23.2002 26.3489",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.dc2bd047f2fd0bf76e9917fee1a0a1be.svg";
export { ForwardRef as ReactComponent };